export enum StatusColor {
    success = 'success',
    alert = 'alert',
    inProgress = 'in-progress',
    inactive = 'inactive',
    ineligible = 'ineligible'
}
